import { render, staticRenderFns } from "./ForwardedRequestsStatus.vue?vue&type=template&id=7d1407dc&scoped=true&"
import script from "./ForwardedRequestsStatus.vue?vue&type=script&lang=js&"
export * from "./ForwardedRequestsStatus.vue?vue&type=script&lang=js&"
import style0 from "./ForwardedRequestsStatus.vue?vue&type=style&index=0&id=7d1407dc&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7d1407dc",
  null
  
)

export default component.exports